export default {
  tab: {
    allExchanges: 'All Exchanges',
    hose: 'HOSE',
    hnx: 'HNX',
    upcom: 'UPCOM',
    vn30: 'VN30',
    hnx30: 'HNX30',
  },

  tabDataChange: {
    tabDataChangeTab: {
      overview: 'OVERVIEW',
      performance: 'PERFORMANCE',
      financial: 'FINANCIAL',
      technical: 'TECHNICAL',
      chart: 'CHART',
    },
  },

  performance: {
    listTitleTable: {
      TICKER: 'TICKER',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE_1DAY: '1 DAY',
      PERCENT_PRICE_CHANGE_1WEEK: '1 WEEK',
      PERCENT_PRICE_CHANGE_2WEEK: '2 WEEKS',
      PERCENT_PRICE_CHANGE_1MONTH: '1 MONTH',
      PERCENT_PRICE_CHANGE_3MONTH: '3 MONTHS',
      PERCENT_PRICE_CHANGE_6MONTH: '6 MONTHS',
      PERCENT_PRICE_CHANGE_9MONTH: '9 MONTHS',
      PERCENT_PRICE_CHANGE_1YEAR: '1 YEAR',
      PERCENT_PRICE_CHANGE_YTD: 'YTD',
    },
  },
  overview: {
    overviewHeader: {
      TICKER: 'TICKER',
      SECTOR_NAME: 'SECTOR',
      VOLUME: 'VOLUME',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE: '% 1D CHANGE',
      RTD11: 'MARKET CAP',
      RTD21: 'P/E',
      RANKING: 'RANKING',
      PB: 'P/B',
      BETA: 'BETA',
    },

    overviewTopValueHeader: {
      TICKER: 'TICKER',
      SECTOR_NAME: 'SECTOR',
      VALUE: 'VALUE',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE: '% 1D CHANGE',
      RTD11: 'MARKET CAP',
      VOLUME: 'VOLUME',
      RANKING: 'RANKING',
      PB: 'P/B',
      PE: 'P/E',
      BETA: 'BETA',
    },

    overviewTopNewHighHeader: {
      TICKER: 'TICKER',
      SECTOR_NAME: 'SECTOR',
      VALUE: 'VALUE',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE: '% 1D CHANGE',
      RTD11: 'MARKET CAP',
      VOLUME: 'VOLUME',
      OLD_HIGH: 'OLD HIGH',
      RANKING: 'RANKING',
      PB: 'P/B',
      BETA: 'BETA',
      PE: 'P/E',
    },

    overviewTopNewLowHeader: {
      TICKER: 'TICKER',
      SECTOR_NAME: 'SECTOR',
      VALUE: 'VALUE',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE: '% 1D CHANGE',
      RTD11: 'MARKET CAP',
      VOLUME: 'VOLUME',
      OLD_LOW: 'OLD LOW',
      RANKING: 'RANKING',
      PB: 'P/B',
      BETA: 'BETA',
      PE: 'P/E',
    },

    overviewTopForeignTradeHeader: {
      TICKER: 'TICKER',
      SECTOR_NAME: 'SECTOR',
      VALUE: 'VALUE',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE: '% 1D CHANGE',
      RTD11: 'MARKET CAP',
      PB: 'P/B',
      BETA: 'BETA',
      VOLUME: 'VOLUME',
      FOREIGN_BUY_VOL: 'NET BUY VOL',
      FOREIGN_BUY_VALUE: 'NET BUY VALUE',
      FOREIGN_SELL_VOL: 'NET SELL VOL',
      FOREIGN_SELL_VALUE: 'NET SELL VALUE',
      OLD_LOW: 'OLD LOW',
      RANKING: 'RANKING',
      RTD21: 'P/E',
      PE: 'P/E',
    },
  },
  financial: {
    financialHeader: {
      ticker: 'TICKER',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE: '% 1D CHANGE',
      ISA3: 'REVENUE<br>(TTM)',
      ISA20: 'NET PROFIT<br>(TTM)',
      RTD14: 'EPS<br>(TTM)',
      RTD7: 'BVPS (VND)<br> (TTM)',
      RTD21: 'P/E',
      RTD25: 'P/B',
      NET_PROFIT_GROWTH: 'Net Profit Growth (TTM)',
      EBIT_MARGIN: 'EBIT MARGIN (TTM)',
      SECTOR_NAME: 'Sector',
    },
  },
  technical: {
    technicalHeader: {
      TICKER: 'TICKER',
      VOLUME: 'VOLUME',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE: '% 1D CHANGE',
      SMA20: 'SMA20',
      SMA50: 'SMA50',
      SMA100: 'SMA100',
      RSI: 'RSI',
      CANDLE_STICK: 'CANDLESTICK',
    },
  },
};
